import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { WorkspaceType } from 'Shared/constants/types';

import RecurringMeetingItemForOnboarding from 'Shared/components/RecurringMeetingItemForOnboarding/RecurringMeetingItemForOnboarding';
import { useForm } from 'react-final-form';
import { useFieldValue } from 'Shared/utils/hooks';
import { generateEmptyWorkspace } from '../../Workspaces/utils';

function RecurringMeetingForm() {
  const recurringMeetings = useSelector(state => state.onboardingState.recurringMeetings);
  const [recurringMeetingsFormData, setRecurringMeetingsFormData] = useState(recurringMeetings);

  const currentUserEmail = useSelector(state => state.user.email);

  const workspaces = useFieldValue('workspaces');
  const workspaces_recurring_meeting_uuids = workspaces.map(({ recurring_meeting_uuid }) => recurring_meeting_uuid);

  const { mutators: formMutators } = useForm();

  const handleFormattedRecurringMeetingUpdate = (updated_uuid, params) => {
    const newRecurringMeetingsFormData = recurringMeetingsFormData.map(meeting => {
      if (meeting.uuid === updated_uuid) {
        return {
          ...meeting,
          ...params,
        };
      }
      return meeting;
    });

    return setRecurringMeetingsFormData(newRecurringMeetingsFormData);
  };

  useEffect(() => {
    const selectedRecurringMeetings = recurringMeetingsFormData.filter(({ selected }) => selected);
    const unSelectedRecurringMeetings = recurringMeetingsFormData.filter(({ selected }) => !selected);
    const selectedRecurringMeetingsNotInWorkspaces = selectedRecurringMeetings.filter(
      ({ uuid }) => !workspaces_recurring_meeting_uuids.includes(uuid)
    );
    const unSelectedRecurringMeetingsInWorkspacesUuids = unSelectedRecurringMeetings
      .filter(({ uuid }) => workspaces_recurring_meeting_uuids.includes(uuid))
      .map(({ uuid }) => uuid);

    const workspaceIndexesToBeRemoved = workspaces
      .map((workspace, index) => {
        if (unSelectedRecurringMeetingsInWorkspacesUuids.includes(workspace.recurring_meeting_uuid)) {
          return index;
        }
        return null;
      })
      .filter(i => i !== null);

    const workspaceIndexesToBeUpdated = workspaces
      .map((workspace, index) => {
        const recurringMeetingForWorkspace = selectedRecurringMeetings.find(
          ({ uuid }) => uuid === workspace.recurring_meeting_uuid
        );

        if (!recurringMeetingForWorkspace) return null;

        const new_workspace_emails = recurringMeetingForWorkspace.inviteAttendees
          ? recurringMeetingForWorkspace.attendees.map(({ email }) => email)
          : null;

        const new_workspace_personalMessage = recurringMeetingForWorkspace.personalMessage;

        if (workspace.emails !== new_workspace_emails || workspace.personalMessage !== new_workspace_personalMessage) {
          return {
            index,
            new_value: { ...workspace, emails: new_workspace_emails, personalMessage: new_workspace_personalMessage },
          };
        }
        return null;
      })
      .filter(i => i !== null);

    const newWorkspaces = selectedRecurringMeetingsNotInWorkspaces.map(
      ({ uuid, teammateName, personalMessage, inviteAttendees, attendees }) => {
        const emails = inviteAttendees ? attendees.map(({ email }) => email) : null;
        return {
          ...generateEmptyWorkspace(),
          recurring_meeting_uuid: uuid,
          fullName: teammateName,
          personalMessage,
          emails,
        };
      }
    );

    workspaceIndexesToBeUpdated.forEach(({ index, new_value }) => {
      formMutators.update('workspaces', index, new_value);
    });

    formMutators.removeBatch('workspaces', workspaceIndexesToBeRemoved);
    formMutators.concat('workspaces', newWorkspaces);
  }, [recurringMeetingsFormData]);

  return (
    <div className="mr-5">
      {recurringMeetingsFormData.map(meeting => (
        <RecurringMeetingItemForOnboarding
          key={meeting.uuid}
          type={WorkspaceType.isTeammate}
          paramsForCreateWorkspace={meeting}
          currentUserEmail={currentUserEmail}
          onParamsForCreateWorkspaceUpdate={handleFormattedRecurringMeetingUpdate}
        />
      ))}
    </div>
  );
}

export default RecurringMeetingForm;
